// Division master configuration
export const DIVISIONS = {
    SCM: {
      id: 'SCM',
      label: 'SCM',
      badgeColor: 'bg-blue-100 text-blue-700',
      borderColor: 'border-blue-300',
      ringColor: 'ring-blue-500'
    },
    TPT: {
      id: 'TPT',
      label: 'TPT', 
      badgeColor: 'bg-green-100 text-green-700',
      borderColor: 'border-green-300',
      ringColor: 'ring-green-500'
    },
    XPR: {
      id: 'XPR',
      label: 'XPR',
      badgeColor: 'bg-red-100 text-red-700',
      borderColor: 'border-red-300',
      ringColor: 'ring-red-500'
    }
  };
  
  export const getDivisionConfig = (division) => {
    return DIVISIONS[division] || DIVISIONS.SCM;
  };
  
  export const getDivisionOptions = () => {
    return Object.values(DIVISIONS);
  };

  export const isValidDivision = (division) => {
    return division in DIVISIONS;
  };